<template>
  <section class="tradition">
    <div class="container">
      <a-typography-title :level="1">
        <span>传统数据迁移方案</span>
        <template v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)">，</template>
        <br v-else />
        <span>难以兼顾成本与速度</span>
      </a-typography-title>
      <a-row :gutter="[40,20]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :xl="8">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              <template v-for="v in item.text">
                <p v-if="v.t1">{{ v.t1 }}</p>
                <span v-if="v.t2">{{ v.t2 }}</span>
              </template>
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_tradition',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '硬盘/专业设备离线迁移',
            text: [
              {
                t1: '设备有丢失和损坏风险'
              },
              {
                t1: '专业设备成本高昂'
              },
              {
                t1: '数据无法实时更新'
              },
              {
                t1: '传输时长以天为单位，周期较长'
              }
            ]
          },
          {
            title: '物理专线在线迁移',
            text: [
              {
                t1: '施工成本高',
                t2: '光纤铺设费、楼内线缆租赁费高达百万元。'
              },
              {
                t1: '使用成本高',
                t2: '一条100Gbps专线每年耗费数十万元。'
              },
              {
                t1: '施工周期长达2-3个月'
              }
            ]
          },
          {
            title: '公网在线传输',
            text: [
              {
                t1: '传输时间长',
                t2: '10TB数据经公网传输需要约10天时间。'
              }
            ]
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/planMigrate/';

.tradition {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg('@{imagePublic}bg_1.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @wh: 80px;
  @style: fade(@color_white, 50), @color_white;
  position: relative;
  min-height: 325px;
  padding: 15px 30px 30px;
  .gradientLinear(0deg, @style);
  border: 2px solid @color_14;
  border-radius: 8px;
  
  .loop(@i) when (@i<=3) {
    &.i_@{i} {
      &::before {
        background-position-x: -(-1+@i)*@wh;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    width: @wh;
    height: @wh;
    margin: 0 auto;
    .bg('@{image}tradition_icon.png', @wh*3, @wh);
  }
  
  h5.ant-typography {
    margin: @margin_mo 0 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    overflow: hidden;
    margin: @margin_mo 0 0;
    
    p {
      position: relative;
      padding-left: 15px;
      margin: 10px 0 0;
      .font(justify, @text+@line, @color_12, @text, true);
      
      &:nth-child(1) {
        margin: 0;
      }
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 10px, auto, auto, 0);
        width: 6px;
        height: 6px;
        background: @color_10;
        border-radius: 50%;
      }
    }
    
    span {
      display: block;
      .font(justify, @font_7+@line, @color_13, @font_7);
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .tradition {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    padding: 20px;
    min-height: auto;
    
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      min-height: auto;
      
      p {
        margin: 0;
        .font(justify, @text_mo+@line_mo, @color_12, @text_mo, true);
      }
      
      span {
        .font(justify, @font_7+@line_mo, @color_13, @font_7);
      }
    }
  }
}
</style>